module.exports = __webpack_public_path__ + "static/media/pause.b1109a0e.svg";